const healthCheckDataJson = [
  {
    apiUrl: '/alert/status/health',
    display: 'Alerts',
  },
  {
    apiUrl: '/automatedmeterread/status/health',
    display: 'AMR',
  },
  {
    apiUrl: '/bulkupload/status/health',
    display: 'Bulk Upload',
  },
  {
    apiUrl: '/config/status/health',
    display: 'Config',
  },
  {
    apiUrl: '/consumption/status/health',
    display: 'Consumption',
  },
  {
    apiUrl: '/content/status/health',
    display: 'Content',
  },
  {
    apiUrl: '/core/status/health',
    display: 'Core',
  },
  {
    apiUrl: '/correspondence/status/health',
    display: 'Correspondence',
  },
  {
    apiUrl: '/dataexport/status/health',
    display: 'Data Export',
  },
  {
    apiUrl: '/documentmanagement/status/health',
    display: 'Document Management',
  },
  {
    apiUrl: '/core/status/ers-gateway/health',
    display: 'ERS Gateway',
  },
  {
    apiUrl: '/ersgatewayadapter/status/health',
    display: 'ERS Gateway Adapter',
  },
  {
    apiUrl: '/identityops/status/health',
    display: 'Identity Ops',
  },
  {
    apiUrl: '/scheduledtasks/status/health',
    display: 'Scheduled Tasks',
  },
  {
    apiUrl: '/signalr/status/health',
    display: 'SignalR',
  },
  {
    apiUrl: '/tpis/status/health',
    display: 'TPIs',
  },
];

export default healthCheckDataJson;
